import React, { lazy } from "react";
import Loadable from "../components/Loadable";
// import { authRoles } from "../auth/authRoles";
import { routeCheck } from "app/data/roles";

// DASHBOARD ROUTES
const Terms = Loadable(lazy(() => import('app/views/useTerms/Terms')));

//GUEST NAVIGATION PATHS
const useTermsPaths = routeCheck(
      [ 
         { path: "/termsOfUse", element: <Terms/> }
      ], 
      false //true: all routes are permited | false (default) all routes are validated
)

export default useTermsPaths ;